<div class="field-dialog__content__scroll p-24 tab-new-general" *ngIf="equipmentForm">
  <div *ngIf="isViewMode" class="tab-new-general__info">
    <mat-icon class="tab-new-general__info-icon">info</mat-icon>
    <p class="tab-new-general__info-text">
      <span>{{ 'EQUIPMENTS.PERMISSIONS.NO_EDIT' | translate }}</span>
    </p>
  </div>

  <div class="tab-new-general__card">
    <p class="tab-new-general__card-title">
      {{ 'EQUIPMENTS.DIALOG.NEW_GENERAL.DETAILS.TITLE' | translate }}
    </p>
    <p class="tab-new-general__card-description">
      {{ 'EQUIPMENTS.DIALOG.NEW_GENERAL.DETAILS.DESCRIPTION' | translate }}
    </p>

    <div class="tab-new-general__card-divider"></div>

    <div class="tab-new-general__card__details">
      <div class="tab-new-general__card__details__picture">
        <input hidden type="file" #pictureInput accept="image/*" (change)="selectPicture($event)" />
        <mat-icon
          *ngIf="!equipmentForm.get('imageUrl').value"
          class="tab-new-general__card__details__picture-add"
          fontSet="material-icons-outlined"
        >
          image
        </mat-icon>

        <ng-container *ngIf="equipmentForm.get('imageUrl').value">
          <img
            class="tab-new-general__card__details__picture-image"
            appImageLoad
            [src]="equipmentForm.get('imageUrl').value.thumb"
            alt="equipment image"
          />
          <div
            *ngIf="!isViewMode"
            class="tab-new-general__card__details__picture__delete"
            [matTooltip]="'EQUIPMENTS.DIALOG.NEW_GENERAL.DETAILS.IMAGE.REMOVE' | translate"
            [matTooltipPosition]="'right'"
            (click)="removePicture()"
          >
            <mat-icon class="tab-new-general__card__details__picture__delete-icon">close</mat-icon>
          </div>
        </ng-container>
      </div>

      <div class="tab-new-general__card__details__picture__container">
        <button
          type="button"
          mat-stroked-button
          color="primary"
          class="tab-new-general__card__details__picture__container-button"
          (click)="pictureInput.click()"
          [disabled]="isViewMode"
        >
          {{ 'EQUIPMENTS.DIALOG.NEW_GENERAL.DETAILS.IMAGE.BUTTON' | translate }}
        </button>
        <p class="tab-new-general__card-description">
          {{ 'EQUIPMENTS.DIALOG.NEW_GENERAL.DETAILS.IMAGE.DESCRIPTION' | translate }}
        </p>
      </div>
    </div>

    <div class="tab-new-general__card__inputs">
      <fc-outlined-input
        [control]="equipmentForm.get('name')"
        [label]="'EQUIPMENTS.DIALOG.NEW_GENERAL.DETAILS.FORM.MODEL_NAME' | translate"
        [required]="true"
        [maxLength]="100"
      >
        <ng-container *ngIf="equipmentForm.get('name').hasError('required')">
          {{ 'EQUIPMENTS.ERRORS.REQUIRED' | translate }}
        </ng-container>
      </fc-outlined-input>

      <fc-equipment-type-input
        [control]="equipmentForm.get('type')"
        [requiredMark]="true"
        [preloadOptions]="true"
        [translateErrorPrefix]="'EQUIPMENTS.ERRORS'"
      ></fc-equipment-type-input>

      <fc-outlined-input
        [control]="equipmentForm.get('number')"
        [label]="'EQUIPMENTS.DIALOG.NEW_GENERAL.DETAILS.FORM.SERIAL_NUMBER' | translate"
        [required]="true"
        [maxLength]="100"
      >
        <ng-container *ngIf="equipmentForm.get('number').hasError('required')">
          {{ 'EQUIPMENTS.ERRORS.REQUIRED' | translate }}
        </ng-container>

        <ng-container *ngIf="equipmentForm.get('number').hasError('equipment_number_duplicated')">
          {{ 'EQUIPMENTS.ERRORS.NUMBER_DUPLICATED' | translate }}
        </ng-container>
      </fc-outlined-input>

      <button
        type="button"
        mat-stroked-button
        color="primary"
        class="tab-new-general__card__inputs__button"
        (click)="equipmentForm.get('qrCode').value ? openQrCodeDialog() : generateQrCode()"
      >
        <mat-icon class="tab-new-general__card__inputs__button-icon">
          {{ equipmentForm.get('qrCode').value ? 'visibility' : 'qr_code' }}
        </mat-icon>
        <span class="tab-new-general__card__inputs__button-text">
          {{
            (equipmentForm.get('qrCode').value
              ? 'EQUIPMENTS.DIALOG.NEW_GENERAL.DETAILS.FORM.QR_CODE.VIEW'
              : 'EQUIPMENTS.DIALOG.NEW_GENERAL.DETAILS.FORM.QR_CODE.ADD'
            ) | translate
          }}
        </span>
      </button>

      <fc-date-input
        [control]="equipmentForm.get('purchasedAt')"
        [label]="'EQUIPMENTS.DIALOG.NEW_GENERAL.DETAILS.FORM.PURCHASE_DATE' | translate"
        translateErrorPrefix="EQUIPMENTS.ERRORS"
      ></fc-date-input>

      <fc-date-input
        [control]="equipmentForm.get('installedAt')"
        [min]="equipmentForm.get('purchasedAt').value"
        [label]="'EQUIPMENTS.DIALOG.NEW_GENERAL.DETAILS.FORM.INSTALLATION_DATE' | translate"
        translateErrorPrefix="EQUIPMENTS.ERRORS"
      ></fc-date-input>

      <fc-text-area-input
        class="tab-new-general__card__inputs__two-columns"
        [label]="'EQUIPMENTS.DIALOG.NEW_GENERAL.DETAILS.FORM.NOTES' | translate"
        [control]="equipmentForm.get('notes')"
        [requiredMark]="false"
        [maxLength]="300"
        translateErrorPrefix="EQUIPMENTS.ERRORS"
      >
      </fc-text-area-input>
    </div>
  </div>

  <div class="tab-new-general__card mt-24">
    <p class="tab-new-general__card-title">
      {{ 'EQUIPMENTS.DIALOG.NEW_GENERAL.LOCATION.TITLE' | translate }}
    </p>
    <p class="tab-new-general__card-description">
      {{ 'EQUIPMENTS.DIALOG.NEW_GENERAL.LOCATION.DESCRIPTION' | translate }}
    </p>

    <div class="tab-new-general__card-divider"></div>

    <div class="tab-new-general__card__inputs">
      <fc-location-input
        class="tab-new-general__card__inputs__two-columns"
        [control]="equipmentForm.get('location')"
        [requiredMark]="true"
        [showSearchIcon]="true"
        [label]="'EQUIPMENTS.DIALOG.NEW_GENERAL.LOCATION.FORM.LOCATION' | translate"
        [translateErrorPrefix]="'EQUIPMENTS.ERRORS'"
      ></fc-location-input>

      <fc-location-sector-input
        [control]="equipmentForm.get('sector')"
        [requiredMark]="false"
        [preloadOptions]="true"
        [translateErrorPrefix]="'EQUIPMENTS.ERRORS'"
        [locationId]="equipmentForm.get('location').value?.id"
        [showChevronIcon]="true"
      ></fc-location-sector-input>

      <fc-location-environment-input
        [control]="equipmentForm.get('environment')"
        [requiredMark]="false"
        [preloadOptions]="true"
        [translateErrorPrefix]="'EQUIPMENTS.ERRORS'"
        [sectorId]="equipmentForm.get('sector').value?.id"
        [showChevronIcon]="true"
      ></fc-location-environment-input>
    </div>
  </div>
</div>
